import type { ReactNode } from 'react';

interface SectionHeadProps {
  id?: string;
  kicker: string;
  kickerZh?: string;
  title: string;
  desc?: string;
  action?: ReactNode;
}

export default function SectionHead({ id, kicker, kickerZh, title, desc, action }: SectionHeadProps) {
  return (
    <div className="mb-8 md:mb-10 flex flex-col gap-4 md:flex-row md:items-end md:justify-between">
      <div className="max-w-3xl">
        <div className="flex items-center gap-3">
          <span className="hidden sm:inline-block h-px w-8 bg-primary-500"></span>
          <span className="text-xs md:text-sm font-bold tracking-[0.22em] text-primary-600 uppercase">
            {kicker}
          </span>
          {kickerZh ? (
            <span className="text-xs text-foreground-400 font-label tracking-widest">{kickerZh}</span>
          ) : null}
        </div>
        <h2 className="mt-3 font-heading text-2xl md:text-4xl font-bold leading-snug text-foreground-950">
          {title}
        </h2>
        {desc ? <p className="mt-3 text-sm md:text-[15px] leading-7 text-foreground-600">{desc}</p> : null}
      </div>
      {action ? <div className="shrink-0">{action}</div> : null}
    </div>
  );
}